var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8733 0.0531249C12.7796 -0.0123825 12.6569 -0.0175622 12.558 0.0389986L0.1489 7.12987C0.0476336 7.18756 -0.0100908 7.29952 0.00145964 7.41553C0.01301 7.53153 0.0914808 7.62991 0.201999 7.66656L3.90766 8.90167L5.33608 12.8061C5.37907 12.9236 5.49073 13 5.61335 13C5.62459 13 5.63615 12.9994 5.64739 12.998C5.72722 12.9888 5.79439 12.9459 5.84186 12.8863L7.94684 10.2482L10.8383 11.212C10.8689 11.2224 10.9004 11.2273 10.9318 11.2273C10.9849 11.2273 11.0377 11.2129 11.0842 11.1849C11.1583 11.1404 11.2091 11.0657 11.2232 10.9803L12.996 0.344017C13.0147 0.231422 12.9671 0.118328 12.8733 0.0531249ZM5.79167 9.12157C5.76137 9.16284 5.74204 9.21101 5.736 9.26181L5.46912 11.4494L4.47947 8.74448L10.2579 3.09912L5.79167 9.12157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.75084a63625879b1ed808ad366c608f6.svg";
export { ForwardRef as ReactComponent };